module.exports = __webpack_public_path__ + "static/img/image_support_article_details_p5.91bf550.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_article_details_p5.png
// module id = R1g9
// module chunks = 10